import React from "react";
import { Box,  Stack, Typography, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function Home() {
  return (
    <Box sx={{ maxWidth: 900, margin: "0 auto" }}>
      <Box sx={{ p: 3 }}>
        <Stack spacing={2}>
          <Typography variant="h4">Sheets</Typography>
          <Typography variant="body1">
            Create and share structured sheets of information (variables, sections and items). Others can suggest fixes; owners/editors can review and apply changes.
          </Typography>

          <Stack direction="row" spacing={1}>
            <Button variant="contained" component={RouterLink} to="/sheet/">
              Browse sheets
            </Button>
            <Button variant="outlined" component={RouterLink} to="/sheet/add">
              Add sheet
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}
